// extracted by mini-css-extract-plugin
module.exports =  {"attributes-wrapper":"DQU4GLM","attributesWrapper":"DQU4GLM"};